import { motion } from 'framer-motion'
import { ExternalLink } from 'lucide-react'

const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
}

export default function InfoUteis() {
    const organizations = [
        {
            name: 'ILGA',
            fullName: 'Intervenção Lésbica, Gay, Bissexual, Trans e Intersexo',
            logo: '/assets/images/2020-logo-ilga.png',
            link: 'https://www.ilga-portugal.pt/',
            topBarColor: 'from-rose-500 to-pink-600',
            border: 'border-rose-100',
            bg: 'hover:bg-rose-50/50'
        },
        {
            name: 'ASSOCIAÇÃO AMPLOS',
            fullName: 'Associação de Mães e Pais pela Liberdade de Orientação Sexual e Identidade de Género',
            logo: '/assets/images/icone2x.png',
            link: 'https://www.amplos.pt/',
            topBarColor: 'from-violet-500 to-purple-600',
            border: 'border-violet-100',
            bg: 'hover:bg-violet-50/50'
        },
        {
            name: 'CASA QUI',
            fullName: 'Associação de Solidariedade Social',
            logo: '/assets/images/logo-casaqui.png',
            link: 'https://www.casa-qui.pt/',
            topBarColor: 'from-teal-500 to-green-600',
            border: 'border-teal-100',
            bg: 'hover:bg-teal-50/50'
        },
        {
            name: 'OPUS DIVERSIDADES',
            fullName: 'Defesa dos direitos humanos com especial incidência nas minorias sexuais e étnicas.',
            logo: '/assets/images/opusdiversidades-v3-pos-1-e1614293733534-768x273.webp',
            link: 'https://opusdiversidades.org/',
            topBarColor: 'from-orange-500 to-amber-600',
            border: 'border-orange-100',
            bg: 'hover:bg-orange-50/50'
        },
        {
            name: 'GAT',
            fullName: 'Grupo de Ativistas em Tratamento',
            logo: '/assets/images/1200x698-recrutamento.png',
            link: 'http://www.gatportugal.org',
            topBarColor: 'from-sky-500 to-blue-600',
            border: 'border-sky-100',
            bg: 'hover:bg-sky-50/50'
        }
    ]

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            className="min-h-screen bg-white"
        >
            <title>Informações Úteis e Entidades de Apoio LGBTI+ | APAV</title>
            <meta name="description" content="Entidades a que as pessoas LGBTI+ em Portugal podem recorrer para apoio noutras questões: ILGA Portugal, AMPLOS, Casa Qui, Opus Diversidades e GAT." />
            <link rel="canonical" href="https://lgbti.apav.pt/infoUteis" />
            {/* Hero Section */}
            <section className="relative overflow-hidden bg-gradient-to-br from-slate-900 via-teal-900 to-blue-900 py-20 lg:py-28">
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute top-0 right-0 w-96 h-96 bg-teal-400 rounded-full filter blur-3xl translate-x-1/2 -translate-y-1/2" />
                    <div className="absolute bottom-0 left-0 w-80 h-80 bg-blue-400 rounded-full filter blur-3xl -translate-x-1/2 translate-y-1/2" />
                </div>
                <div className="container-custom relative z-10">
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7, delay: 0.1 }}
                    >
                        <h1 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                            Informações Úteis
                        </h1>
                        <p className="text-slate-300 text-lg max-w-2xl">
                            Se é uma pessoa LGBTI+ e precisa de apoio para outras questões, existem várias entidades a que pode recorrer.
                        </p>
                    </motion.div>
                </div>
            </section>

            {/* Organizations Grid */}
            <section className="py-10 lg:py-14 bg-slate-50">
                <div className="container-custom">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {organizations.map((org, index) => (
                            <motion.div
                                key={index}
                                variants={fadeUp}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                transition={{ duration: 0.5, delay: index * 0.08 }}
                                className={`bg-white rounded-2xl shadow-xs border ${org.border} overflow-hidden flex flex-col group hover:-translate-y-1 hover:shadow-lg transition-all duration-300 ${org.bg}`}
                            >
                                {/* Top accent bar */}
                                <div className={`h-1.5 bg-gradient-to-r ${org.topBarColor} w-full`} />

                                {/* Logo */}
                                <div className="flex items-center justify-center h-36 px-8 pt-6 pb-4">
                                    <img
                                        src={org.logo}
                                        alt={org.name}
                                        className="max-h-full max-w-full object-contain"
                                    />
                                </div>

                                {/* Content */}
                                <div className="flex flex-col flex-1 px-6 pb-6">
                                    <h2 className="text-base font-bold text-slate-900 mb-2 text-center">{org.name}</h2>
                                    <p className="text-slate-500 text-sm mb-6 text-center flex-1 leading-relaxed">{org.fullName}</p>
                                    <a
                                        href={org.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-gradient-to-r from-rose-600 to-pink-700 text-white font-semibold text-sm shadow-md hover:opacity-90 transition-opacity focus-visible:ring-2 focus-visible:ring-brand-700 focus-visible:ring-offset-2"
                                    >
                                        Aceder
                                        <ExternalLink size={14} />
                                    </a>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>
        </motion.div>
    )
}
